import React from 'react';
import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import InfiniteCarousel from 'react-leaf-carousel';

import './Home.scss';

import useNewsPosts from 'hooks/useNewsPosts';
import useBreakerCarousel from 'hooks/useBreakerCarousel';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/blur.css';

import SVG from 'react-inlinesvg';

import breakerplaceholder from '../../assets/img/breaker-placeholder.png';
import join from '../../assets/img/joinus.jpg';

import egg1 from '../../assets/img/egg-step1.jpg';
import egg1video from '../../assets/img/egg-step1-video.mp4';
import egg2 from '../../assets/img/egg-step2.jpg';
import egg2video from '../../assets/img/egg-step2-video.mp4';
import egg3 from '../../assets/img/egg-step3.jpg';
import egg3video from '../../assets/img/egg-step3-video.mp4';

import poster from '../../assets/img/egg/mint-video.jpg';
import vid1 from '../../assets/img/egg/mint-video.webm';
import vid2 from '../../assets/img/egg/mint-video.mp4';

import gribeggs from '../../assets/img/gribble-eggs-logo.svg';

import { formatDate } from 'utils/date';
import { routes } from '../../routing/routes';
import { useFlags, FLAGS } from 'hooks/useFlags';
import PreHatcheningHome from './PreHatcheningHome';
import HatcheningHome from './HatcheningHome';

function OldHome() {
  const { homepageNewsPosts, isLoading } = useNewsPosts();
  const { breakers } = useBreakerCarousel();

  const joinimg = {
    background: 'url(' + join + ') no-repeat center center',
    backgroundSize: 'cover',
  };

  if (isLoading || !homepageNewsPosts) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="home"
    >
      {/* ======================== New HERO Block */}

      <section
        className="
          has-bg d-flex flex-column p-0 justify-content-center height-70 mobile-height-auto
          "
      >
        <div className="is-video-bg center">
          <div className="video-bg-overlay center"></div>
          <video autoPlay loop controls={false} poster={poster}>
            <source src={vid1} type="video/webm" />
            <source src={vid2} type="video/mp4" />
          </video>
        </div>

        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-5 order-2 order-lg-1">
              <div className="py-4 py-lg-6 home-title">
                <h1 className="mb-4 text-center">
                  <SVG className="gribble-egg-logo" src={gribeggs} title="Gribble Eggs!" />
                </h1>
                <p className="text-center">
                  DuskBreakers is a vast Sci-Fi web3 game franchise. Our second collection mint, The
                  Gribbles, and new game, Twilight Shift, are LIVE. Through the Gribble
                  Eggsperience, you control the evolution of your Gribble from Egg to fully evolved
                  3D adult. The power to evolve is in your&nbsp;hands.
                </p>
                <p className="text-center">
                  Don’t have an Egg? Play Twilight Shift for a chance to mint your very own Gribble
                  Egg and join the Gribble&nbsp;Eggsperience!
                </p>
                <p className="text-center">
                  <a className="btn btn-primary" href={routes.egg.mint()}>
                    Mint now!
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======================== Close New HERO Block */}
      {/* ======================== New HOW IT WORKS Block */}

      <section className="bg-black pt-5 pb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <h2 className="text-center mt-0 mb-4">The Eggsperience Explained</h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video autoPlay loop controls={false} alt="Mint" poster={egg1} muted playsInline>
                  <source src={egg1video} type="video/mp4" />
                </video>
                <div className="card-body h-100">
                  <p className="text-huge mb-2">Mint</p>
                  <p className="mt-2">
                    Mint your eggs and begin your Gribble Eggsperience. Play Twilight Shift to earn
                    even more Egg mints via our Play to Mint system.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video autoPlay loop controls={false} alt="Play" poster={egg2} muted playsInline>
                  <source src={egg2video} type="video/mp4" />
                </video>
                <div className="card-body">
                  <p className="text-huge mb-2">Play</p>
                  <p className="mt-2">
                    Play Twilight Shift, enter Adrian’s Sanctuary, and complete missions to earn
                    OmniGrow, the essential element in a Gribble’s evolution. Missions updated
                    regularly!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4 mb-lg-0">
              <div className="card h-100 m-0">
                <video
                  autoPlay
                  loop
                  controls={false}
                  alt="Grow"
                  poster={egg3}
                  muted
                  playsInline
                  className="hatch-video"
                >
                  <source src={egg3video} type="video/mp4" />
                </video>
                <div className="card-body">
                  <p className="text-huge mb-2">Evolve</p>
                  <p className="mt-2">
                    Apply the OmniGrow you’ve earned to your Egg to enhance its evolution. Earn and
                    apply OmniGrow frequently to hatch the strongest, most radiant 3D Gribble!
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col pt-4">
              <p className="text-center">
                <a className="btn btn-outline-primary" href={routes.mint()}>
                  Join the Eggsperience
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ======================== Close HOW IT WORKS Block */}
      {/* ======================== UNDERHERO Block */}
      <section
        className="
            pt-4 underhero
          "
      >
        <div className="container-fluid">
          <div className="row pt-lg-0">
            <div className="col">
              <h2 className="text-center">Latest News</h2>
            </div>
          </div>

          <div className="row g-4">
            {homepageNewsPosts.slice(0, 4).map(({ id, title, imageUrl, publishDate, slug }) => {
              return (
                <div key={id} className="col-12 col-sm-6 col-lg-3">
                  <div className="linkcard card h-100 mb-0">
                    <LazyLoadImage
                      className="card-img-top"
                      alt={title}
                      src={imageUrl}
                      effect="opacity"
                    />
                    <div className="card-body">
                      <div className="text-small text-muted mb-2">
                        <span>{formatDate(publishDate)}</span>
                      </div>
                      <Link className="stretched-link" to={`/news/${id}/${slug}`}>
                        {title}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row">
            <div className="col">
              <p className="text-center pt-3 m-0">
                <a href={routes.news.base()}>View all news</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ======================== Close UNDERHERO Block */}

      {/* ======================== CAROUSEL Block */}
      <section className="has-bg">
        <InfiniteCarousel
          breakpoints={[
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
          ]}
          dots={false}
          showSides={true}
          sidesOpacity={0.5}
          sideSize={0.1}
          slidesToScroll={1}
          slidesToShow={5}
          scrollOnDevice={true}
        >
          {breakers.map(({ id, name, imageUrl, isCanonBreaker }) => {
            return (
              <Link className="noline" key={id} to={`/gallery?breakerId=${id}`}>
                <figure>
                  <LazyLoadImage
                    className={`rounded breaker-carousel-img ${isCanonBreaker ? 'isCanon' : ''}`}
                    alt="Breaker in a gallery"
                    src={imageUrl}
                    placeholderSrc={breakerplaceholder}
                    effect="blur"
                  />
                  <figcaption className="text-small text-center text-muted pt-2">{name}</figcaption>
                </figure>
              </Link>
            );
          })}
        </InfiniteCarousel>

        <div className="container">
          <div className="row">
            <div className="col">
              <div className="mt-4">
                <h2 className="text-center">Genesis Breakers</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="">
                <p className="text-center">
                  Our 10,000 Genesis NFT collection represents the first generation of DuskBreakers
                  in our universe. Learn more about them and their adventures on the Lore page.
                </p>

                <div className="d-flex justify-content-center pt-4">
                  <Link
                    className="btn btn-outline-primary me-4"
                    to={routes.lore.base()}
                    role="button"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="is-bg stripes-top" />
      </section>
      {/* ======================== Close CAROUSEL Block */}

      {/* ======================== JOIN US Block */}
      <section
        className="
            height-60
            d-flex
            align-items-center
            justify-content-center
            has-bg
          "
      >
        <div className="container">
          <div
            className="
                row
                d-flex
                align-items-center
                justify-content-center
              "
          >
            <div className="col-lg-6 py-4">
              <h2 className="text-center">Join Us</h2>
              <p className="text-center">
                Join your fellow Breakers and friends for community events, giveaways, discussions,
                AMAs, and updates on the DuskBreakers world on{' '}
                <a target="_new" href="https://discord.gg/duskbreakers">
                  Discord
                </a>{' '}
                and{' '}
                <a target="_new" href="https://twitter.com/duskbreakers">
                  Twitter
                </a>
                !
              </p>
              <div className="pt-4 d-flex justify-content-center">
                <a
                  className="btn btn-primary"
                  role="button"
                  href="https://discord.gg/duskbreakers"
                  target="_new"
                >
                  Discord
                </a>
              </div>
            </div>
          </div>
          <div className="is-bg" style={joinimg} />
        </div>
      </section>
      {/* ======================== Close JOIN US Block */}

      <Footer />
    </m.main>
  );
}

export default function Home() {
  const { isFlagEnabled } = useFlags();

  return isFlagEnabled(FLAGS.hatchening) ? (
    <HatcheningHome />
  ) : isFlagEnabled(FLAGS.preHatchening) ? (
    <PreHatcheningHome />
  ) : (
    <OldHome />
  );
}
